/* Login screen */
import React, { useState, useEffect, Suspense } from "react";
import Footer from "../../components/Common/Footer";
import { useHistory } from "react-router-dom";
import { handleAppRedirect, handleAppRedirectCurrentPage, isMobile, isFailedDeepLink, silentlyRedirectToIOSApp } from "../../utils/appRedirect";
let LoginPage;
export default function Login(props) {
    const [hasLoaded, setHasLoaded] = useState(false);
    const [state, setState] = useState({
        message: undefined,
        toggle: true,
        modal: window.location.pathname === "/terms" ? true : false,
        modalReset: window.location.pathname === "/reset" ? true : false,
        modalResetConfirm:
            window.location.pathname === "/reset_confirm" ? true : false,
        modalFAQ: window.location.pathname === "/help" ? true : false,
        focus: false,
        logo: undefined,
    });
    const history = useHistory();
    if (!hasLoaded) {
        loginBrandPage(props.customBrand);
    }
    useEffect(() => {
        LoginPage = React.lazy(() =>
            import(
                "../../brands/" + props.customBrand + "/components/Login/Login"
            )
        );
    }, [props]); //
    // Handle app redirect for /terms page on mobile (fallback only)
    useEffect(() => {
        if (window.location.pathname === "/terms" && isMobile()) {
            // Only attempt redirect if this looks like a failed deep link
            // App.js will handle most automatic redirects, this is just a fallback
            if (isFailedDeepLink()) {
                console.log("Terms page accessed on mobile via failed deep link - attempting fallback app redirect");
                handleAppRedirectCurrentPage(); // Use current page with all query parameters and hash
            } else {
                console.log("Terms page accessed directly on mobile - showing app banner");
                // Just show the banner, don't auto-redirect
            }
        }
    }, []); // Run once on component mount
    function loginBrandPage(brand) {
        LoginPage = React.lazy(() =>
            import("../../brands/" + brand + "/components/Login/Login")
        );
        setHasLoaded(true);
    }
    //
    function toggleAddProfile() {
        setState({
            modal: !state.modal,
        });
        if (!state.modal === false) {
            window.location.hostname === "wifi.hyperleapnetwork.com" 
         || window.location.hostname === "devdd01.wifikey.link" ? 
            history.push("/login")
            :
            history.push("/")
        }
    }
    function toggleReset() {
        setState({
            modalReset: !state.modalReset,
        });
        if (!state.modalReset === false) {
         window.location.hostname === "wifi.hyperleapnetwork.com" 
         || window.location.hostname === "devdd01.wifikey.link" ? 
            history.push("/login")
            :
            history.push("/")
        }
    }
    function toggleResetConfirm() {
        setState({
            modalResetConfirm: !state.modalResetConfirm,
        });
        if (!state.modalResetConfirm === false) {
         window.location.hostname === "wifi.hyperleapnetwork.com" 
         || window.location.hostname === "devdd01.wifikey.link" ? 
            history.push("/login")
            :
            history.push("/");
        }
    }
    function toggleFAQ() {
        setState({
            modalFAQ: !state.modalFAQ,
        });
        if (!state.modalFAQ === false) {
         window.location.hostname === "wifi.hyperleapnetwork.com" 
         || window.location.hostname === "devdd01.wifikey.link" ? 
            history.push("/login")
            :
            history.push("/");
        }
    }
    return (
        <>
            <Suspense fallback={
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    backgroundColor: '#f8f9fa'
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '2rem',
                        borderRadius: '8px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        textAlign: 'center'
                    }}>
                        <div className="spinner-border text-primary mb-3" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        <h5 className="mb-2">Loading Login Page</h5>
                        <p className="text-muted mb-0">Please wait while we prepare your experience...</p>
                    </div>
                </div>
            }>
                {/* Mobile App Banner for /terms page */}
                {/* {window.location.pathname === "/terms" && isMobile() && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: '#007bff',
                        color: 'white',
                        padding: '10px 15px',
                        textAlign: 'center',
                        fontSize: '14px',
                        zIndex: 9999,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}>
                        <span>📱 Get the best experience with our mobile app! </span>
                        <button 
                            onClick={() => {
                                console.log('🚀 User clicked "Open App" from banner');
                                // Attempt silent redirect to app
                                silentlyRedirectToIOSApp(
                                    window.location.pathname + window.location.search,
                                    () => console.log('✅ App opened from banner click'),
                                    () => console.log('📱 App not installed - staying on web')
                                );
                            }}
                            style={{
                                backgroundColor: 'transparent',
                                border: '1px solid white',
                                color: 'white',
                                padding: '4px 12px',
                                marginLeft: '8px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                cursor: 'pointer'
                            }}
                        >
                            Open App
                        </button>
                    </div>
                )} */}
                <LoginPage
                    brand={props.brand}
                    customBrand={props.customBrand}
                    data={props.data}
                    logoLogin={props.logoLogin}
                    logoMobile={props.logoMobile}
                    flagFooter={props.flagFooter}
                    flagSignup={props.flagLoginSignup}
                    toggleAddProfile={toggleAddProfile}
                    toggleReset={toggleReset}
                    toggleResetConfirm={toggleResetConfirm}
                    toggleFAQ={toggleFAQ}
                    modal={state.modal}
                    modalReset={state.modalReset}
                    modalResetConfirm={state.modalResetConfirm}
                    modalFAQ={state.modalFAQ}
                    setState={setState}
                    operatorName={props.operatorName}
                />
                {props.flagFooter ? <Footer /> : ""}
            </Suspense>
        </>
    );
}
